/**
 * Display-only progress for the top bar: level, coins and how many
 * companions the user has met. **No game mechanic behind it yet** (Oct
 * 2026): the numbers are derived from chat activity on this device so the
 * app shows what the progression layer will look like. Replace with
 * server-side values when the real system lands.
 */

export type ProgressInput = {
  messagesSent: number;
  companionsMet: number;
  streakDays: number;
};

export type Progress = {
  level: number;
  title: string;
  /** 0-1 towards the next level. */
  levelProgress: number;
  coins: number;
};

const TITLES = [
  "Newcomer",
  "Explorer",
  "Wanderer",
  "Pathfinder",
  "Storyteller",
  "Legend",
];

function xp({
  messagesSent,
  companionsMet,
  streakDays,
}: ProgressInput): number {
  return messagesSent * 10 + companionsMet * 50 + streakDays * 25;
}

/** XP needed to reach `level` (level 1 = 0). Grows with the square of the level. */
function xpFor(level: number): number {
  return 100 * (level - 1) ** 2;
}

export function progressOf(input: ProgressInput): Progress {
  const points = xp(input);
  let level = 1;
  while (xpFor(level + 1) <= points) level++;
  const from = xpFor(level);
  const to = xpFor(level + 1);
  return {
    level,
    title: TITLES[Math.min(level - 1, TITLES.length - 1)],
    levelProgress: (points - from) / (to - from),
    // A welcome balance, then coins for showing up and talking.
    coins:
      50 +
      input.messagesSent * 5 +
      input.companionsMet * 20 +
      input.streakDays * 10,
  };
}
